module.exports = __webpack_public_path__ + "static/media/porady-dla-rodzicow.4bf731c9.png";